import gql from 'graphql-tag'

const invoiceRecipientProperties = gql`
  fragment InvoiceRecipientProperties on InvoiceRecipient {
    id
    name
    streetAddress
    postalCode
    postalArea
    email
    recipientType
    organizationNumber
  }
`

const productProperties = gql`
  fragment ProductProperties on Product {
    id
    name
    descriptions
    isRecommended
    category
    ... on PhotoBasedProduct { quantity }
    ... on MeasurementProduct { quantity }
    ... on AdvertisingProduct { advertisingVariants extraSpending }
    ... on FloorPlansProduct { floors measurement }
    ... on StandardPhotoProduct { residence }
    ... on StylingProduct { basic, plus }
    ... on VideoProduct { videoVariant drone creativeResource teaser broker }
    ... on SlideshowProduct { slideshowVariant }
    ... on VirtualTourProduct { variant }
    ... on PlanDrawingProduct { redraw, measurements }
  }
`

export const initialPropertiesOnWebOrder = gql`
  fragment InitialPropertiesOnWebOrder on WebOrder {
    address {
      id
      street
      postalCode
      postalArea
      location {
        lon
        lat
      }
    }
    availableProducts(first: 40) {
      edges {
        node {
          ...ProductProperties
        }
      }
    }
    broker {
      id
      productAvailability {
        typenames
        premiumService
        videoTypes {
          name
          type
          extraProductOptions
          exampleUrl
        }
        advertisingTypes {
          name
          type
          extraProductOptions
          description
          standalone
        }
        slideshowTypes {
          name
          type
          description
          exampleUrl
        }
      }
    }
    bundles(first: 20) {
      edges {
        node {
          id
          name
          price
          priceIncVat
          consumerPrice
          premiumService
          products(first: 50) {
            edges {
              node {
                ...ProductProperties
              }
            }
          }
        }
      }
    }
    cadastreAddressId
    customer {
      id
      showOptionsForInvoiceRecipient
      chain {
        id
        name
      }
    }
    estateSellers {
      id
      name
      email
      phone
    }
    estate {
      id
      floors
      streetAddress
      m2
      postponedBookings {
        id
        products {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
    floors
    m2
    floorNumber
    invoiceRecipientAlternatives {
      ...InvoiceRecipientProperties
    }
    m2
    segment {
      id
      type
    }
    thirdPartyApplicationName
  }
  ${invoiceRecipientProperties}
  ${productProperties}
`

export const updatingPropertiesOnWebOrder = gql`
  fragment UpdatingPropertiesOnWebOrder on WebOrder {
    id
    bundleId
    expressDelivery
    premiumService
    pickUpKeys
    pickUpKeysInstructions
    estateAddressDoorbell
    additionalEstateAddressInfo
    messageForPhotographer
    messageForCustomerService
    preferredPhotographer
    preferredStylist
    preferredResourceDate
    preferredResourcePriority
    sendInvoiceByEmail
    selfBookingAvailability {
      isAvailable
      unavailabilityReason
    }
    invoiceRecipient {
      ...InvoiceRecipientProperties
    }
    bill {
      sum
      sumIncVat
      lines {
        description
        quantity
        unit
        unitPrice
        bundleId
        itemId
        sum
      }
    }
    reservedBooking {
      id
      startsAt
      endsAt
      expiresAt
      serviceProvider {
        id
        name
      }
    }
    selectedProducts {
      ...ProductProperties
    }
  }
  ${invoiceRecipientProperties}
  ${productProperties}
`

export default {
  initialPropertiesOnWebOrder,
  updatingPropertiesOnWebOrder,
}
